import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import { 
  ArrowRight, 
  ShieldCheck, 
  Dumbbell, 
  MapPin, 
  Trophy, 
  GraduationCap, 
  PartyPopper, 
  Target 
} from "lucide-react";
import { AuthContext } from "../context/AuthContext";
import { userRoles } from "../App";
import "../assets/styles/discover.css";

export default function DiscoverCampus() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  if (user?.role === userRoles.externalorganizer || !user) {
    return null;
  }

  // 4 كروت للأنشطة (بنظام ثنائي اللغة زي ما طلبت)
  const categories = [
    {
      icon: <Trophy size={26} />,
      title: "الأنشطة الرياضية",
      subtitle: "Sports & Tournaments",
      route: "/activities/categories/sports",
      colorVar: "blue",
    },
    {
      icon: <GraduationCap size={26} />,
      title: "الأنشطة الأكاديمية",
      subtitle: "Academic & Workshops",
      route: "/activities/categories/academic",
      colorVar: "purple",
    },
    {
      icon: <PartyPopper size={26} />,
      title: "الأنشطة الترفيهية",
      subtitle: "Entertainment & Concerts",
      route: "/activities/categories/entertainment",
      colorVar: "pink",
    },
    {
      icon: <Target size={26} />,
      title: "المسابقات والتحديات",
      subtitle: "Competitions & Prizes",
      route: "/activities/categories/competitions",
      colorVar: "orange",
    },
  ];

  // 3 كروت للخدمات (زي ما هي بالظبط)
  const services = [
    {
      icon: <ShieldCheck size={26} />,
      title: "التربية العسكرية",
      subtitle: "Military Education",
      route: "/activities/categories/military-education",
      colorVar: "navy",
    },
    {
      icon: <Dumbbell size={26} />,
      title: "الجيم الرياضي",
      subtitle: "Campus Gym",
      route: "/activities/categories/gym-status",
      colorVar: "red",
    },
    {
      icon: <MapPin size={26} />,
      title: "حجز الملاعب",
      subtitle: "Courts Booking",
      route: "/activities/categories/sports-schedule",
      colorVar: "emerald",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  };

  return (
    <section className="campus-hub-section">
      {/* تأثير الإضاءة الفخم في الخلفية */}
      <div className="hub-glow-bg"></div>

      <div className="container position-relative z-2">
        <div className="text-center mb-5">
          {/* خليت العنوان الرئيسي كمان يمشي على نفس الستايل */}
          <motion.h2
            className="hub-main-title"
            initial={{ opacity: 0, y: -10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            مركز الأنشطة <span>Hub</span>
          </motion.h2>
          <motion.p 
            className="hub-subtitle"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            All your activities and services in one place
          </motion.p>
        </div>

        {/* ==================================
            1. Activities Row (4 Columns)
            ================================== */}
        <motion.div
          className="hub-grid-4"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {categories.map((item, index) => (
            <motion.div
              key={index}
              className={`micro-card theme-${item.colorVar}`}
              variants={itemVariants}
              onClick={() => navigate(item.route)}
            >
              <div className="mc-icon-box">{item.icon}</div>
              <div className="mc-info">
                <h4 style={{ fontWeight: '700' }}>{item.title}</h4>
                <p style={{ opacity: 0.8, fontSize: '0.85rem' }}>{item.subtitle}</p>
              </div>
              <div className="mc-arrow"><ArrowRight size={18} /></div>
            </motion.div>
          ))}
        </motion.div>

        {/* ==================================
            2. Services Row (3 Columns)
            ================================== */}
        <motion.div
          className="hub-grid-3 mt-3 mt-md-4"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {services.map((item, index) => (
            <motion.div
              key={index}
              className={`micro-card theme-${item.colorVar}`}
              variants={itemVariants}
              onClick={() => navigate(item.route)}
            >
              <div className="mc-icon-box">{item.icon}</div>
              <div className="mc-info text-md-end">
                <h4 style={{ fontWeight: '700' }}>{item.title}</h4>
                <p style={{ opacity: 0.8, fontSize: '0.85rem' }}>{item.subtitle}</p>
              </div>
              <div className="mc-arrow"><ArrowRight size={18} /></div>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}

// import React, { useContext } from "react";
// import { useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";

// import { 
//   ArrowRight, 
//   ShieldCheck, 
//   Dumbbell, 
//   MapPin, 
//   Trophy, 
//   GraduationCap, 
//   PartyPopper, 
//   Target 
// } from "lucide-react";
// import { AuthContext } from "../context/AuthContext";
// import { userRoles } from "../App";
// import "../assets/styles/discover.css";

// export default function DiscoverCampus() {
//   const navigate = useNavigate();
//   const { user } = useContext(AuthContext);

//   if (user?.role === userRoles.externalorganizer || !user) {
//     return null;
//   }

//   // 4 كروت للأنشطة
//   const categories = [
//     {
//       icon: <Trophy size={26} />,
//       title: "Sports",
//       subtitle: "Tournaments & matches",
//       route: "/activities/categories/sports",
//       colorVar: "blue",
//     },
//     {
//       icon: <GraduationCap size={26} />,
//       title: "Academic",
//       subtitle: "Workshops & seminars",
//       route: "/activities/categories/academic",
//       colorVar: "purple",
//     },
//     {
//       icon: <PartyPopper size={26} />,
//       title: "Entertainment",
//       subtitle: "Concerts & fun events",
//       route: "/activities/categories/entertainment",
//       colorVar: "pink",
//     },
//     {
//       icon: <Target size={26} />,
//       title: "Competitions",
//       subtitle: "Challenges & prizes",
//       route: "/activities/categories/competitions",
//       colorVar: "orange",
//     },
//   ];

//   // 3 كروت للخدمات
//   const services = [
//     {
//       icon: <ShieldCheck size={26} />,
//       title: "التربية العسكرية",
//       subtitle: "Military Education",
//       route: "/activities/categories/military-education",
//       colorVar: "navy",
//     },
//     {
//       icon: <Dumbbell size={26} />,
//       title: "الجيم الرياضي",
//       subtitle: "Campus Gym",
//       route: "/activities/categories/gym-status",
//       colorVar: "red",
//     },
//     {
//       icon: <MapPin size={26} />,
//       title: "حجز الملاعب",
//       subtitle: "Courts Booking",
//       route: "/activities/categories/sports-schedule",
//       colorVar: "emerald",
//     },
//   ];

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
//   };

//   const itemVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
//   };

//   return (
//     <section className="campus-hub-section">
//       {/* تأثير الإضاءة الفخم في الخلفية */}
//       <div className="hub-glow-bg"></div>

//       <div className="container position-relative z-2">
//         <div className="text-center mb-5">
//           <motion.h2
//             className="hub-main-title"
//             initial={{ opacity: 0, y: -10 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//           >
//             Campus <span>Hub</span>
//           </motion.h2>
//           <motion.p 
//             className="hub-subtitle"
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             viewport={{ once: true }}
//           >
//             All your activities and services in one place
//           </motion.p>
//         </div>

//         {/* ==================================
//             1. Activities Row (4 Columns)
//             ================================== */}
//         <motion.div
//           className="hub-grid-4"
//           variants={containerVariants}
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, margin: "-50px" }}
//         >
//           {categories.map((item, index) => (
//             <motion.div
//               key={index}
//               className={`micro-card theme-${item.colorVar}`}
//               variants={itemVariants}
//               onClick={() => navigate(item.route)}
//             >
//               <div className="mc-icon-box">{item.icon}</div>
//               <div className="mc-info">
//                 <h4>{item.title}</h4>
//                 <p>{item.subtitle}</p>
//               </div>
//               <div className="mc-arrow"><ArrowRight size={18} /></div>
//             </motion.div>
//           ))}
//         </motion.div>

//         {/* ==================================
//             2. Services Row (3 Columns)
//             ================================== */}
//         <motion.div
//           className="hub-grid-3 mt-3 mt-md-4"
//           variants={containerVariants}
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//         >
//           {services.map((item, index) => (
//             <motion.div
//               key={index}
//               className={`micro-card theme-${item.colorVar}`}
//               variants={itemVariants}
//               onClick={() => navigate(item.route)}
//             >
//               <div className="mc-icon-box">{item.icon}</div>
//               <div className="mc-info text-md-end">
//                 <h4>{item.title}</h4>
//                 <p>{item.subtitle}</p>
//               </div>
//               <div className="mc-arrow"><ArrowRight size={18} /></div>
//             </motion.div>
//           ))}
//         </motion.div>

//       </div>
//     </section>
//   );
// }

